export default "__VITE_ASSET__BeAgPc0Y__"